export { useControleDeErros } from './controle-de-erros.hook'
export * from './controle-de-erros.interface'
